import { toCdnMediaUrl } from "../utils/cdnMediaUrl";

function stripTrailingSlash(url) {
  return String(url || "").replace(/\/+$/, "");
}

function envUrl(value) {
  return stripTrailingSlash(
    String(value || "")
      .trim()
      .replace(/^['"]|['"]$/g, "")
  );
}

/**
 * API host only (no trailing slash, no /api).
 * Values come only from .env — no hardcoded hosts.
 */
export function getMosidaApiOrigin() {
  const ws = envUrl(process.env.REACT_APP_BASE_URL_WS);
  if (ws) return ws;

  const apiBase = envUrl(process.env.REACT_APP_API_BASE_URL);
  if (apiBase) {
    return apiBase.replace(/\/api\/?$/, "");
  }

  console.error(
    "[mosidaApi] Missing MOSIDA API origin. Set REACT_APP_BASE_URL_WS or REACT_APP_API_BASE_URL in .env"
  );
  return "";
}

/** REST base including /api — prefers REACT_APP_API_BASE_URL when set. */
function getMosidaApiBaseUrl() {
  const explicit = envUrl(process.env.REACT_APP_API_BASE_URL);
  if (explicit) {
    return /\/api$/i.test(explicit) ? explicit : `${explicit}/api`;
  }
  const origin = getMosidaApiOrigin();
  return origin ? `${origin}/api` : "";
}

export const MOSIDA_API_ORIGIN = getMosidaApiOrigin();
export const MOSIDA_API_BASE_URL = getMosidaApiBaseUrl();

/** Giftshop uses REACT_APP_PAYMENT_SECRET_KEY; kiosks often use REACT_APP_KIOSK_SECRET_KEY. */
export const PAYMENT_SECRET_KEY =
  envUrl(process.env.REACT_APP_PAYMENT_SECRET_KEY) ||
  envUrl(process.env.REACT_APP_KIOSK_SECRET_KEY);

/** Google AI / shared AI services host (merch generate, remove-bg, etc.). */
export function getAiServicesOrigin() {
  const origin = envUrl(process.env.REACT_APP_AI_SERVICES_ORIGIN);
  if (!origin) {
    console.error(
      "[mosidaApi] Missing REACT_APP_AI_SERVICES_ORIGIN in .env"
    );
  }
  return origin;
}

export function getPaymentRedirectOrigin() {
  const origin = envUrl(process.env.REACT_APP_FRONTEND_BASE_URL);
  if (!origin) {
    console.error(
      "[mosidaApi] Missing REACT_APP_FRONTEND_BASE_URL in .env"
    );
  }
  return origin;
}

export function resolvePaymentOrderType(items, paymentType) {
  if (paymentType) return paymentType;
  const allOnsite =
    Array.isArray(items) &&
    items.length > 0 &&
    items.every((item) => item.type === "onsite-printing");
  return allOnsite ? "onsite" : "offsite";
}

export function resolvePaymentRedirectUrl(items, options = {}) {
  const origin = getPaymentRedirectOrigin();
  if (!origin) return "";
  const orderType = resolvePaymentOrderType(items, options.paymentType);
  const path =
    orderType === "onsite" ? "kiosk-payment-link-onsite" : "shipping-information";
  return `${origin}/${path}?type=${orderType}`;
}

export function buildImageReadApiUrl(sourceUrl) {
  const trimmed = String(sourceUrl || "").trim();
  if (!trimmed) return trimmed;
  if (/^(data:|blob:)/i.test(trimmed)) return trimmed;
  if (trimmed.includes("/api/image-processing/read?url=")) return trimmed;
  const publicUrl = toCdnMediaUrl(trimmed) || trimmed;
  if (!MOSIDA_API_ORIGIN) return publicUrl;
  return `${MOSIDA_API_ORIGIN}/api/image-processing/read?url=${encodeURIComponent(
    publicUrl
  )}`;
}
